import styled, { css } from 'styled-components';
import { P as PortalComponent } from '../Portal/PortalComponent-VEfCtCOY.js';

const OuterWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-1aw4l4w-0"
})(["box-sizing:border-box;outline:none;", " position:fixed;@media (prefers-reduced-motion:no-preference){transition:", ";}opacity:0;opacity:", ";z-index:500;", " ", " > &&{width:max-content;}"], ({
  $hideOverflow
}) => $hideOverflow && 'overflow: hidden;', ({
  transition
}) => transition, ({
  transitionState
}) => ({
  entering: 0,
  entered: 1,
  exiting: 0,
  exited: 0,
  unmounted: 0
})[transitionState], ({
  withBackdrop
}) => withBackdrop && `
    border: none;
    border-radius: 8px;
    background-color: #FFFFFF;
    box-shadow: 0 4px 8px 0 rgb(35 47 63 / 0.20), 0 0 2px 0 rgb(35 47 63 / 0.30);
  `, PortalComponent);
OuterWrapper.displayName = 'OuterWrapper';
function contentOverflowRules({
  $disableContentScroll,
  $hideOverflow
}) {
  if (!$disableContentScroll && $hideOverflow) {
    return css(["overflow-y:auto;overflow-x:hidden;"]);
  }
  if ($disableContentScroll && $hideOverflow) {
    return css(["overflow:hidden;"]);
  }
  if (!$disableContentScroll && !$hideOverflow) {
    return css(["overflow-y:auto;"]);
  }
  return css([""]);
}
const Content = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-1aw4l4w-1"
})(["box-sizing:border-box;word-wrap:break-word;", " ul,ol{color:inherit;}"], contentOverflowRules);
Content.displayName = 'Content';

export { Content as C, OuterWrapper as O };
//# sourceMappingURL=PopoverLegacy.styles-BMaDe9hH.js.map
